import { useAppDispatch, useAppSelector } from "../../hooks/reduxhooks";
import Dialog from "../../components/Dialog/Dialog";
import { OauthLogout } from "utils/User/logout";
import { resetSessionTimer } from "../../redux/slices/userSlice";
import useUpdateUserInfomation from "hooks/User/useUpdateUserInfomation";
import { useCallback, useMemo } from "react";
import { TokenManager } from "@forgerock/javascript-sdk";

const SessionTimeout = () => {
  const activityStatus = useAppSelector(
    (state) => state.userSlice.activityStatus
  );
  const { updateUser } = useUpdateUserInfomation();
  const dispatch = useAppDispatch();

  const resumeSession = useCallback(async () => {
    dispatch(resetSessionTimer());
    const tokens = await TokenManager.getTokens({
      login: "redirect",
    });
    if (tokens) {
      await updateUser();
    }
  }, [dispatch, updateUser]);

  const sessionDialog = useMemo(() => {
    switch (activityStatus) {
      case "online":
        return null; // No message needed when online
      case "idle":
        return (
          <Dialog
            open={true}
            onClose={resumeSession}
            title="Session is about to expire"
            message="Your session is about to expire due to inactivity. Do you want to continue?"
            primaryBtnText="Continue"
            primaryBtnAction={resumeSession}
            primaryBtnColor="primary"
            secndryBtnText="Log out"
            secndryBtnAction={OauthLogout}
          />
        );
      case "offline": {
        OauthLogout();
        break;
      }
      default:
        return undefined;
    }
  }, [activityStatus, dispatch, updateUser]);

  return sessionDialog;
};

export default SessionTimeout;
